'use strict';

const _ = require('lodash');
const jQuery = require('jquery');

const Container = require('./../../core/container');
const Zone = require('./../structure/zone');
const Translator = require('./../../core/translator');

const itemTpl = require('./template/item.hbs');
const linkTpl = require('./template/link.hbs');

let config = require('./config');

module.exports.onMenuClick = function() {
  let $list = jQuery('<ul class="help-list"></ul>');

  _.forEach(config.items, function(item) {
    let $item = jQuery(itemTpl(item));
    $list.append($item);
  });

  Zone.setSmallPanel('Help', $list);
};

module.exports.onGlobalMenuClick = function() {
  let locale = Translator.getLocale();
  let url = config.links.global[locale];
  window.open(url);
};

module.exports.createLink = function(key) {
  if (Container.get('isMobile')) {
    return '';
  }

  let $link = jQuery(linkTpl({'key': key}));

  let locale = Translator.getLocale();
  let url = config.links[key];

  if (url && url[locale]) {
    url = url[locale];
  } else {
    url = config.links.global[locale];
  }

  $link.on('click', function() {
    window.open(url);
  });

  return $link;
};
